







import Vue from "vue";
import { mapGetters } from "vuex";

// Components
import ChartLine from "@/views/App/Dashboard/ChartsCard/ChartLine.vue";

// Model
import moment from "moment";
import { Brand_Green } from "@/utility/Constants";
import { BagsCashReportEntry } from "@/model/data/bagsCashReport/BagsCashReportEntry";
import { TransactionBagDetails } from "@/model/data/bagsCashReport/TransactionBagDetails";
import { TransactionFlowEnum } from "@/model/data/enums/TransactionFlowEnum";

export default Vue.extend({
    components: {
        ChartLine,
    },
    data() {
        return {
            moment,
        };
    },
    props: {
        showDetailsDialogEntry: { type: Object as () => BagsCashReportEntry },
    },
    computed: {
        ...mapGetters(["longDateFormat"]),

        labels() {
            var res = [];
            // res.push(this.$t("branchReport.initialContent"));

            // var indexBatch = Math.trunc(this.showDetailsDialogEntry.details.length / 2);
            this.showDetailsDialogEntry.details.forEach((e, index) => {
                // res.push(index % indexBatch == 0 ? this.moment(e.transactionTimestamp).format(this.longDateFormat(true, false, false, true, false)) : "");
                res.push("");
            });
            res.push("");

            // res.push(this.$t("branchReport.finalContent"));

            return res;
            // return this.showDetailsDialogEntry.details.map((c) => this.moment(c.transactionTimestamp).format(this.longDateFormat(true, false, false, true, false)));
        },

        datasetsData() {
            var res = [];

            res.push(this.showDetailsDialogEntry.initialContent);

            this.showDetailsDialogEntry.details.forEach((e: TransactionBagDetails) => {
                if (e.flow == TransactionFlowEnum.CashIn) res.push(res[res.length - 1] + e.cashValue);
                else if (e.flow == TransactionFlowEnum.CashOut) res.push(res[res.length - 1] - e.cashValue);
            });

            res.push(this.showDetailsDialogEntry.finalContent);

            return res;
        },

        datasets() {
            var res = [];
            res.push({
                label: "Content",
                data: this.datasetsData,
                fill: true,
                backgroundColor: "rgba(0, 227, 150,0.4)",
                borderColor: Brand_Green,
            });
            return res;
        },
    },
    watch: {
        datasetsData: {
            handler() {
                this.$refs.chart.renderChartMethod();
            },
            deep: true,
        },
    },
});
